<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      @addNew='addNew'
      :count='count'
      :current='page'
      :disablePage='disablePage'
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>应付订单号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
                      v-model.trim='query.payableCode'></lk-input>
          </div>
           <div class="queryItem">
            <label>验收/退货单号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
                      v-model.trim='query.inspectOrRefundCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker placeholder=" 请选择" type='daterange' class="item" v-model.trim='query.createTimeRange'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>审批通过时间:</label>
            <timeStampDatePicker placeholder=" 请选择" type='daterange' class="item" v-model.trim='query.passTimeRange'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
                      v-model.trim='query.createUserName'></lk-input>
          </div>
          <div class="queryItem">
            <label>审批状态:</label>
            <lk-select class="item" clearable v-model.trim='query.payableStatus'>
              <lk-option v-for="(item,index) in statuslist" :key="index" :value='index+1'>{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>供应商:</label>
            <SupplierListSelect v-model="query.supplierId"></SupplierListSelect>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <StoreListSelect v-model.trim='query.storeIdList' class="item"></StoreListSelect>
          </div>
          <div class="queryItem">
            <label>发票编码:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
                      v-model.trim='query.invoiceCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>开票时间:</label>
            <timeStampDatePicker placeholder=" 请选择" class="item" v-model.trim='query.invoiceDate'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <lk-button type='primary' @click="$router.push({name:'payableAdd'})"
                     v-if="handlePermission('payableAdd')">
            +新建应付单
          </lk-button>
          <lk-button v-if="handlePermission('paymentAddBtn')" :disabled='!toPaymentIDs.length' @click="handleToPayment">生成付款单</lk-button>
          <DownloadButton  @on-click="handleExport" v-if="handlePermission('payableExcel')"></DownloadButton>
        </div>
        <lk-table class="cancelTableShadow" border :columns='columns' :data='tableData' @on-selection-change='getSelected'></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import finance from '../../services/finance';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
// import DTPModal from '../../components/DTPModal.vue';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'payable',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    // DTPModal
    SupplierListSelect,
    DownloadButton,
  },
  computed: {
    roleType() {
      return this.$store.state.user.roleType;
    },
  },
  data() {
    return {
      // belongStoreList:[],
      disablePage: false,
      supplierIds: [],
      statuslist: ['草稿', '审批中', '审批通过', '审批未通过', '已撤回', '废弃'],
      params: {},
      query: {
        payableCode: '',
        createUserName: '',
        createTimeRange: [],
        passTimeRange: [],
        supplierId: null,
        // supplierCode: '',
        invoiceCode: '',
        invoiceDate: null,
      },
      toPaymentIDs: [],
      subcolumns: [
        { title: '单号', key: 'referCode', minWidth: 116 },
        { title: '商品通用名称', key: 'approvedDrugName', minWidth: 130 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '单价', key: 'priceBeforeTax', minWidth: 116 },
        { title: '确认进价', key: 'realPriceWithTax', minWidth: 116 },
        { title: '数量', key: 'num', minWidth: 116 },
        { title: '确认税率', key: 'realInputTaxRate', minWidth: 116 },
        { title: '确认不含税单价', key: 'realPriceAfterTax', minWidth: 116 },
        { title: '确认单个税额', key: 'realTax', minWidth: 116 },
        { title: '确认含税总金额', key: 'confirmedTotalAmount', minWidth: 116 },
        { title: '确认总税额', key: 'realTotalTax', minWidth: 116 },
      ],
      columns: [
        { type: 'selection', width: 52 },
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h('lk-table', {
            props: {
              columns: this.subcolumns,
              data: params.row.subData,
            },
          }),
        },
        { title: '应付单号', key: 'code', minWidth: 116 },
        { title: '供应商名称', key: 'supplierName', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 },
        { title: '发票号码', key: 'invoiceCode', minWidth: 116 },
        { title: '开票日期', key: 'invoiceDate', minWidth: 116 },
        { title: '发票总金额', key: 'invoiceAmount', minWidth: 116 },
        { title: '发票不含税金额', key: 'invoiceAmountWithoutTax', minWidth: 130 },
        { title: '发票税额', key: 'invoiceTotalTax', minWidth: 116 },
        { title: '票折总金额', key: 'totalDiscountAmount', minWidth: 116 },
        { title: '确认总金额', key: 'amount', minWidth: 116 },
        { title: '确认不含税总金额', key: 'amountWithoutTaxDisplay', minWidth: 136 },
        { title: '确认总税金', key: 'totalTaxDisplay', minWidth: 116 },
        {
          title: '不含税差额',
          key: 'amountWithoutTaxBalance',
          minWidth: 116,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.amountWithoutTaxBalance !== 0,
            },
          }, params.row.amountWithoutTaxBalance),
        },
        {
          title: '税差额',
          key: 'taxBalance',
          minWidth: 116,
          render: (h, params) => h('span', {
            class: {
              blue: params.row.taxBalance !== 0,
            },
          }, params.row.taxBalance),
        },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '成本变更单', key: 'costNo', minWidth: 130 },
        { title: '创建时间', key: 'createTime', minWidth: 130 },
        { title: '审批通过时间', key: 'passTime', minWidth: 130 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('payableCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'payableCheck', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,
            this.handlePermission('payableEdit') && (params.row.status !== 3 && params.row.status !== 6) ? h('lk-button', {
              props: {
                type: 'text',
                // [1'草稿', 2'审批中', 3'审批通过', 4'审批未通过'],
                disabled: (params.row.status === 2 || params.row.status === 3),
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'payableEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑') : null,
            this.handlePermission('payableAbolish') && (params.row.status === 1 || params.row.status === 4 || params.row.status === 5) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '提示',
                    content: '是否确认废弃此应付单',
                    onOk: () => {
                      this.abolish(params.row.id);
                    },
                  });
                },
              },
            }, '废弃') : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleToPayment() {
      if ([...(new Set(this.supplierIds))].length > 1) {
        this.$Message.error('请选择相同供应商的应付单');
        return;
      }
      this.$router.push({
        name: 'paymentAdd',
        params: {
          financePayableList: this.toPaymentIDs,
        },
      });
    },
    getSelected(list) {
      this.toPaymentIDs = [];
      this.supplierIds = [];
      list.forEach((item) => {
        this.toPaymentIDs.push({ id: item.id });
        this.supplierIds.push(item.supplierId);
      });
    },
    clear() {
      this.query = {
        payableCode: '',
        createUserName: '',
        createTimeRange: [],
        passTimeRange: [],
        supplierId: '',
        invoiceCode: '',
        invoiceDate: null,
        storeIdList: [],
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.createTimeRange && this.params.createTimeRange.length) {
        this.params.createTimeStart = this.params.createTimeRange[0];
        this.params.createTimeEnd = this.params.createTimeRange[1];
        delete this.params.createTimeRange;
      }
      if (this.params.passTimeRange && this.params.passTimeRange.length) {
        this.params.passTimeStart = this.params.passTimeRange[0];
        this.params.passTimeEnd = this.params.passTimeRange[1];
        delete this.params.passTimeRange;
      }
      // if (this.params.createTime) {
      //   this.params.createTime = (new Date(this.params.createTime)).getTime();
      // }
      // if (this.params.invoiceDate) {
      //   this.params.invoiceDate = (new Date(this.params.invoiceDate)).getTime();
      // }
      // console.log(this.params);
      finance.getFinancePayableList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            item.financePayable.subData = item.financePayableInfoList;
            const formatItem = utils.deepClone(item.financePayable);
            utils.exchangeTable(formatItem, result);
            result.subData.forEach((el, index) => {
              const elItem = {};
              utils.exchangeTable(el, elItem);
              elItem.realInputTaxRate += '%';
              result.subData[index] = utils.deepClone(elItem);
            });
            result.loading = false;
            result.invoiceDate = result.invoiceDate ? utils.exchangeTime(result.invoiceDate) : '';
            result.createTime = result.createTime ? utils.exchangeTimeToSecond(result.createTime) : '';
            result.passTime = result.passTime ? utils.exchangeTimeToSecond(result.passTime) : '';
            result._disabled = !result.ableToCreatePayment;
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.$router.push({ name: 'storeAdd' });
    },
    handleExport() {
      if (this.params.createTimeRange && this.params.createTimeRange.length) {
        this.params.createTimeStart = this.params.createTimeRange[0];
        this.params.createTimeEnd = this.params.createTimeRange[1];
        delete this.params.createTimeRange;
      }
      if (this.params.passTimeRange && this.params.passTimeRange.length) {
        this.params.passTimeStart = this.params.passTimeRange[0];
        this.params.passTimeEnd = this.params.passTimeRange[1];
        delete this.params.passTimeRange;
      }
      const params = utils.deepClone(this.params);
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      delete this.params.page;
      delete this.params.size;

      finance.financePayableDownload(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    abolish(params) {
      finance.financePayableAbolish({ financePayableId: params }).then((res) => {
        if (res.data.success === false) {
          setTimeout(() => {
            this.$Modal.confirm({
              title: '该应付单不支持取消，原因如下',
              content: res.data.error,
            });
          }, 200);
        } else {
          this.$Message.success('提交成功');
          this.getData();
        }
      });
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
  .btns{
    margin-bottom: 12px;
    >*{
      margin-right: 16px
      }
    }
  .queryContainer{//样式写进公共类中
    display: flex;
    padding-bottom: 16px;
      flex-wrap: wrap;

    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
  .blue {
    color: #1890FF;
  }
</style>
